var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09417 4.215C7.82333 3.99 9.58583 3.875 11.375 3.875C13.1642 3.875 14.9267 3.99083 16.6558 4.215C18.2575 4.42333 19.3983 5.76583 19.4933 7.32083C19.2147 7.22802 18.926 7.16899 18.6333 7.145C16.2985 6.95118 13.9515 6.95118 11.6167 7.145C9.65167 7.30833 8.25 8.97 8.25 10.84V14.4117C8.24921 15.0981 8.43814 15.7715 8.79593 16.3574C9.15372 16.9432 9.66644 17.4188 10.2775 17.7317L8.06667 19.9417C7.97926 20.029 7.86795 20.0884 7.74678 20.1125C7.62561 20.1365 7.50003 20.1242 7.3859 20.0769C7.27176 20.0296 7.17419 19.9496 7.10551 19.8469C7.03682 19.7443 7.00011 19.6235 7 19.5V16.1417C6.69766 16.1095 6.3957 16.074 6.09417 16.035C4.42083 15.8167 3.25 14.3608 3.25 12.7183V7.53167C3.25 5.89 4.42083 4.43333 6.09417 4.21583V4.215Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 8.25C13.9783 8.25 12.8425 8.2975 11.72 8.39084C10.4367 8.4975 9.5 9.58584 9.5 10.8408V14.4117C9.5 15.6675 10.44 16.7567 11.725 16.8617C12.7608 16.9467 13.8083 16.9925 14.865 16.9992L17.1833 19.3167C17.2707 19.404 17.3821 19.4634 17.5032 19.4875C17.6244 19.5115 17.75 19.4992 17.8641 19.4519C17.9782 19.4046 18.0758 19.3246 18.1445 19.2219C18.2132 19.1193 18.2499 18.9985 18.25 18.875V16.8833L18.525 16.8617C19.81 16.7575 20.75 15.6675 20.75 14.4117V10.84C20.75 9.58584 19.8125 8.4975 18.53 8.39C17.3974 8.29635 16.2614 8.24964 15.125 8.25V8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.250d9c6ff864d7fae374d7195732f2ff.svg";
export { ForwardRef as ReactComponent };